// extracted by mini-css-extract-plugin
export default {"boton":"RolListaScreen_boton__XVseI","containerTable":"RolListaScreen_containerTable__3dFrx","subtitulo":"RolListaScreen_subtitulo__DrfrU"};